var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-detail"},[_c('Banner',{attrs:{"url":_vm.bannerUrl}}),_c('b-container',{attrs:{"fluid":"xl"}},[_c('div',{staticClass:"fb"},[_c('LeftWrapper',{attrs:{"data":_vm.companyDetail}}),_c('RightWrapper',{attrs:{"data":_vm.companyDetail}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }